// GraphQL errors carry the server's message, which for model queries is the warehouse's own error naming the bad column or view.
export const getErrorMessage = (error: unknown): string | undefined =>
  error instanceof Error && error.message ? error.message : undefined;
